'use strict'

var process = {
	env: {
		NODE_ENV: 'production',
	},
}
